import { APICore } from "helpers/api/apiCore";
import config from "../../../config";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function fetchExcessRefundApi(params: FilterMetadata) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-refund/refunds`;
  return api.get(`${baseUrl}`, params);
}

function fetchExcessRefundByExternalIdApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-refund/refunds/${params?.id}`;
  return api.get(`${baseUrl}`, {});
}

export { fetchExcessRefundApi, fetchExcessRefundByExternalIdApi };
